import { render, staticRenderFns } from "./UsersTableHeader.vue?vue&type=template&id=ba6a0bf6&"
import script from "./UsersTableHeader.vue?vue&type=script&lang=js&"
export * from "./UsersTableHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports